import { ArrowNarrowLeftIcon } from "@heroicons/react/solid";
import { useEffect, useRef, useState } from "react";
import { CheckBar, CoinSelector, FormInput } from "../components/CommonComponents";
import Button from "../components/control/Button";
import { ListSelector } from "../components/ListSelector";
import { LoadingSVG } from "../components/Svgs";
import { ToastType, useToast } from "../components/Toast";
import API from "../conf/API";
import { Events, JSEvent } from "../utils/JSEvent";
import { post, request } from "../utils/request";
import DataCenter from "./DataCenter";
import { Localize, LocalStr } from "./localize/Localize";
import { WalletService } from "./WalletService";

const onDataReady = () => {
    AddressBook.load();
}

JSEvent.on(Events.DataCenter.DATA_READY, onDataReady);

export const AddressBook = {
    loaded: false,
    walletAddresses: [],

    load: (coinType, transferNet) => {
        return new Promise((resolve, reject) => {
            if (AddressBook.loaded) {
                resolve(AddressBook.filter(coinType, transferNet));
                return;
            }
            request(API.wallet_address_list()).then(ret => {
                if (ret.error) {
                    reject(ret.msg)
                } else {
                    AddressBook.walletAddresses = ret.retObject;
                    AddressBook.loaded = true;
                    for (let i = 0; i < AddressBook.walletAddresses.addresses.length; i++) {
                        let a = AddressBook.walletAddresses.addresses[i];
                        if (a.fromName == '') {
                            a.fromName = a.tag;
                        }
                    }
                    resolve(AddressBook.filter(coinType, transferNet));
                }
            })
        })
    },

    findAddress: (address) => {
        const { walletInfo } = WalletService;
        if (walletInfo != null) {
            if (walletInfo.address == address) {
                return { fromName: Localize.getMsg(Localize.UI.WalletView.defiWallet) };
            }
        }
        if (AddressBook.walletAddresses.addresses == null) return null;
        for (let i = 0; i < AddressBook.walletAddresses.addresses.length; i++) {
            const a = AddressBook.walletAddresses.addresses[i];
            if (a.address == address) {
                return a;
            }
        }
        return null;
    },

    filter: (coinType, transferNet) => {
        const addrs = [];

        if (WalletService.walletInfo != null) {
            addrs.push({
                id: 0, coinType: -1, address: WalletService.walletInfo.address,
                transferNet: WalletService.blockchain.key, fromType: 0, fromName:
                    Localize.getMsg(Localize.UI.WalletView.defiWallet)
                , tag: Localize.getMsg(Localize.UI.WalletView.myDefiWallet)
            })
        }

        AddressBook.walletAddresses.addresses.forEach(a => {
            if (transferNet == null || a.transferNet == transferNet) {
                if (coinType == null || coinType <= 0 || coinType == a.coinType || a.coinType <= 0) {
                    addrs.push(a);
                }
            }
        })
        return addrs;
    },

    addOrUpdate: (address) => {
        if (AddressBook.loaded) {
            let added = false;
            for (const idx in AddressBook.walletAddresses.addresses) {
                if (AddressBook.walletAddresses.addresses[idx].id == address.id) {
                    AddressBook.walletAddresses.addresses[idx] = address;
                    added = true;
                    break;
                }
            }
            if (!added) {
                AddressBook.walletAddresses.addresses.push(address);
            }
        }
    }
}

export const PopWnd_AddressBook = ({ onViewAction, selAddr, coinType, transferNet }) => {
    const [addrList, setAddrList] = useState(null);
    const [currSelAddr, setCurrSelAddr] = useState(selAddr);

    useEffect(() => {
        AddressBook.load(coinType, transferNet).then(list => {
            setAddrList(list);
        })
    }, [])

    useEffect(() => {
        setCurrSelAddr(selAddr);
    }, [selAddr]);

    let addrPanel = null;
    const addrBtns = [];

    const AddrItem = ({ item, isSelected }) => {

        const coinType = item.coinType <= 0 ? Localize.getMsg(Localize.COMMON.Common) :
            <div className=" text-link">{DataCenter.getCoin(item.coinType).name}</div>;

        const from = item.fromName == "" ? null : <div className=" text-link">{item.fromName}</div>

        return <div className="flex-col w-full">
            <div className="flex items-center">
                <div className="flex pr-2 font-semibold text-xl">{item.tag}</div>
                <div className="flex mr-2 px-1 py-0.5 bg-gray-200 text-sm rounded-md">{coinType}</div>
                <div className="flex px-1 py-0.5 bg-gray-200 text-sm rounded-md">{from}</div>
            </div>
            <div className="flex w-full text-gray-500 text-xs pt-1">
                {item.address}
            </div>
        </div>
    }

    if (addrList == null) {
        addrPanel = <div className="flex w-full h-full justify-center items-center">{LoadingSVG}</div>;
    } else if (addrList.length == 0) {
        addrBtns.push(<Button name="L:UI.AddressBookView.newAddress" type="primary" widthStyle="w-full" onClicked={e => {
            onViewAction("newAddress");
            onViewAction("close");
        }} />);
    } else if (addrList.length > 0) {
        addrPanel = <ListSelector list={addrList}
            currSel={currSelAddr == null ? -1 : currSelAddr.id}
            onSelect={item => {
                setCurrSelAddr(item);
            }} listItem={AddrItem} />

        addrBtns.push(<Button key="new" name="L:UI.AddressBookView.newAddress" widthStyle="w-full" className="mx-2" onClicked={e => {
            onViewAction("newAddress");
            onViewAction("close");
        }} />);
        addrBtns.push(<Button key="ok" name="L:COMMON.Confirm" type="primary" widthStyle="w-full" className="mx-2" onClicked={e => {
            onViewAction({ name: "selAddress", value: currSelAddr });
            onViewAction("close");
        }} />);
    }


    return <>
        <div className="flex w-full max-h-72 h-full overflow-hidden">
            {addrPanel}
        </div>
        <div className="mt-4 flex justify-between items-center">
            {addrBtns}
        </div>
    </>
}


export const AddressBookView = ({ walletAddr, addView, fireViewAction }) => {
    const [title, setTitle] = useState("");
    const [currCoin, setCurrCoin] = useState(null);
    const [isGeneral, setGeneral] = useState(walletAddr != null && walletAddr.coinType == -1);
    const [loading, showLoading] = useState(false);

    const inputAddress = useRef();
    const inputAddrFrom = useRef();
    const inputAddrTag = useRef();

    const [makeToast] = useToast();

    useEffect(() => {
        if (walletAddr == null) {
            setTitle(Localize.getMsg(Localize.UI.AddressBookView.newAddress))
        } else {
            setTitle(Localize.getMsg(Localize.UI.AddressBookView.editAddress))
        }
    }, [walletAddr])

    return <div className="flex flex-col w-full h-full bg-white p-4">
        <div className=' w-full h-8 flex flex-row items-center justify-center' onClick={() => fireViewAction({ name: "close" })}>
            <ArrowNarrowLeftIcon className="h-6 text-gray-500" aria-hidden="true" />
            <div className="flex flex-1 font-semibold justify-center items-center text-xl">{title}</div>
        </div>
        <LocalStr msg={Localize.COMMON.Coin} className="text-sm text-gray-600 pt-4" />
        <div className='bg-gray-100 w-full mt-1 mb-1 rounded-lg pl-5 pr-5 h-12 flex flex-col justify-center'>
            {
                isGeneral ? <LocalStr msg={Localize.UI.AddressBookView.universalAddr} className="text-gray-600" />
                    : <CoinSelector onCoinSelected={coin => {
                        setCurrCoin(coin)
                    }} />
            }
        </div>
        <CheckBar text={Localize.getMsg(Localize.UI.AddressBookView.setAsUniversal)} className=" text-sm h-6 text-gray-400" checked={isGeneral}
            onChange={c => {
                setGeneral(c);
            }}
        />

        <LocalStr msg={Localize.COMMON.address} className="text-sm text-gray-600 pt-4" />
        <div className="flex w-full text-xs">
            <FormInput name="address"
                ref={inputAddress}
                validInput={(name, value) => {
                    const valid = WalletService.provider.isValidAddress(value);
                    if (!valid) {
                        return Localize.getMsg(Localize.UI.WithdrawView.checkAddressTip);
                    }
                }} />
        </div>

        <LocalStr msg={Localize.COMMON.transferNet} className="text-sm text-gray-600 pt-4" />
        <div className=" bg-gray-100 px-3 py-2 rounded-md mt-1">
            {WalletService.blockchain.text}
        </div>

        <LocalStr msg={Localize.UI.AddressBookView.addressSource} className="text-sm text-gray-600 pt-4" />
        <FormInput name="addrFrom"
            ref={inputAddrFrom}
            validInput={(name, value) => ""} />

        <LocalStr msg={Localize.UI.AddressBookView.addressTag} className="text-sm text-gray-600 pt-4" />
        <FormInput name="addrTag"
            ref={inputAddrTag}
            validInput={(name, value) => {
                if (value.length == 0) {
                    return Localize.getMsg(Localize.UI.AddressBookView.inputTag);
                }
            }} />
        <div className="flex flex-1 items-end pb-4">
            <Button name="L:COMMON.Save" type="primary" widthStyle="w-full" onClicked={e => {
                const validAddr = inputAddress.current.validateInput()
                const validFrom = inputAddrFrom.current.validateInput()
                const validTag = inputAddrTag.current.validateInput();

                if (validAddr.valid && validTag.valid) {

                    const body = {
                        id: 0,
                        coinType: isGeneral ? -1 : currCoin.id,
                        address: validAddr.value,
                        transferNet: WalletService.blockchain.key,
                        fromType: 0,
                        fromName: validFrom.value,
                        tag: validTag.value
                    }

                    post(API.wallet_address_add(), body).then(ret => {
                        if (ret.error) {
                            makeToast(ret.msg, ToastType.wrong, "toast-address-error")
                        } else {
                            makeToast(Localize.getMsg(Localize.UI.AddressBookView.successful, body.tag), ToastType.right, "toast-address-right")
                            AddressBook.addOrUpdate(ret.retObject);
                            fireViewAction({ name: "close" });
                        }
                    })
                }
            }} />
        </div>
    </div>
}